import {
  markRafflePrizeCollectedResDto,
  RaffleCollectionStatus,
  raffleItemResDto,
  rafflesResDto,
  raffleWinnersOrganizerResDto,
} from '@web/common';
import { authenticatedAPI } from '../AuthenticatedAPI';
import { z } from 'zod';

export const activeRaffleData = async () => {
  return authenticatedAPI.get(`/api/raffle/active`, rafflesResDto);
};

export const futureRaffleData = async () => {
  return authenticatedAPI.get(`/api/raffle/future`, rafflesResDto);
};

export const pastRaffleData = async () => {
  return authenticatedAPI.get(`/api/raffle/past`, rafflesResDto);
};

export const wonRaffles = async (status?: RaffleCollectionStatus) => {
  const query = status ? `?status=${status}` : '';
  return authenticatedAPI.get(`/api/raffle/won${query}`, rafflesResDto);
};

export const raffleByIdData = async (raffleId: string) => {
  return authenticatedAPI.get(`/api/raffle/${raffleId}`, raffleItemResDto);
};

export const betOnRaffle = async (raffleId: string) => {
  return authenticatedAPI.post(
    `/api/loyality-points/bet/${raffleId}`,
    undefined,
    z.any(),
  );
};

// --- Organizer/Shop Employee endpoints ---
export const getRaffleWinnersForOrganizer = async (collected?: boolean) => {
  const query = collected !== undefined ? `?collected=${collected}` : '';
  return authenticatedAPI.get(
    `/api/raffle-winners${query}`,
    raffleWinnersOrganizerResDto,
  );
};

export const markRafflePrizeCollected = async (
  raffleId: string,
  userId: string,
) => {
  return authenticatedAPI.patch(
    `/api/raffle-winners/${raffleId}/${userId}`,
    { collected: true },
    markRafflePrizeCollectedResDto,
  );
};
